import React, { useState } from 'react';
import { X } from 'lucide-react';
import { cip } from '../assets/assets';
import { Link } from 'react-router-dom';
import { useForgotPassword } from '../services/auth/auth';
import { useAlert } from '../context/AlertContext';

const ForgotPassword = ({ onClose }) => {
    const { mutateAsync: forgotPassword } = useForgotPassword();
    const setAlert = useAlert();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await forgotPassword({ email });
            setAlert({ type: 'success', message: response.message || 'Password reset link sent to your email!' });
            setEmail('');
        } catch (error) {
            const err = error.response?.data?.error || 'Failed to process password reset';
            setAlert({ type: 'error', message: err });
            console.log(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="font-['Poppins'] bg-gray-50 min-h-screen flex md:flex-row flex-col">
            {/* Image section */}
            <div className="w-[88%] mt-[4rem] md:mt-0 mx-auto md:w-1/2 md:max-h-screen">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 z-10 md:hidden"
                    aria-label="Close"
                >
                    <Link to={"/clients/signin"}>
                        <X size={24} className="text-gray-800" />
                    </Link>
                </button>

                <img
                    src={cip}
                    alt="Person using keyboard"
                    className="w-full h-64 md:h-full object-cover"
                />
            </div>

            {/* Form section */}
            <div className="md:w-1/2 px-6 py-8 md:px-16 md:py-12 md:flex md:flex-col md:justify-center">
                <h1 className="text-2xl font-bold text-[#174568] mb-2">Forgot Password</h1>
                <p className="text-gray-600 mb-6">Enter your email address and we'll send you a link to reset your password.</p>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="email" className="block text-gray-700 mb-2">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Your email address"
                            className="w-full p-3 border border-[#C1C7CD] md:border-x-0 md:border-t-0 md:bg-[#F2F4F8] bg-transparent rounded-md md:rounded-none focus:outline-none focus:border-[#174568] md:focus:border-b-[#174568] md:focus:border-x-0 md:focus:border-t-0"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full bg-[#174568] hover:bg-gray-800 text-white font-medium py-3 px-4 transition-colors disabled:opacity-70 flex justify-center items-center"
                    >
                        {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                    </button>

                    <div className="text-left mt-6">
                        <Link to="/clients/signin" className="text-[#001D6C] hover:underline">Back to Sign In</Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
